module.exports = __webpack_public_path__ + "assets/fonts/Gotham-LightItalic.8b482b3a.otf";